import { render, staticRenderFns } from "./lockAuthThrow.vue?vue&type=template&id=019aa455&scoped=true"
import script from "./lockAuthThrow.vue?vue&type=script&lang=js"
export * from "./lockAuthThrow.vue?vue&type=script&lang=js"
import style0 from "./lockAuthThrow.vue?vue&type=style&index=0&id=019aa455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019aa455",
  null
  
)

export default component.exports